/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Toast, { ToastTypeEnum } from '../../common/components/ShowToast';
// import LoadingScreen from '../../components/LoadingScreen';
import { useDispatch } from 'react-redux';
import { getUser, postAzureLoginCode, postGoogleLoginCode } from '../../services/authService';
import { updateUser } from '../../slices/userSlice';

const Callback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [toast, setToast] = useState<{
    message: string;
    type: ToastTypeEnum;
    detail?: string;
  } | null>(null);

  useEffect(() => {
    const fullUrl = window.location.href;
    const callbackCode = fullUrl.split('code=')[1]?.split('&')[0];
    const stateVar = fullUrl.split('state=')[1]?.split('&')[0];
    const state = stateVar.split('%26')[0];
    const tenantId = stateVar.split('%26')[1];
    const tenantSlug = stateVar.split('%26')[2];
    const redirectUri = `${window.location.origin}/auth/callback`;

    const handleCallback = async () => {
      const existingUser = await getUser();
      if (existingUser) {
        navigate('/');
        return;
      }

      if (!callbackCode) {
        console.error('Callback code is missing.');
        navigate('/login');
        return;
      }

      if (!tenantId) {
        console.error('Tenant info not found.');
        navigate('/login');
        return;
      }

      try {
        let loginPromise: Promise<boolean>;
        if (state === 'Google') {
          loginPromise = postGoogleLoginCode(callbackCode, redirectUri, tenantId);
        } else if (state === 'Microsoft') {
          loginPromise = postAzureLoginCode(callbackCode, redirectUri, tenantId);
        } else {
          console.warn('Unknown or missing state. Defaulting to Microsoft login.');
          loginPromise = postAzureLoginCode(callbackCode, redirectUri, tenantId);
        }

        loginPromise
          .then(() => {
            return getUser(true);
          })
          .then((user) => {
            if (user) {
              dispatch(updateUser(user));
              setToast({ message: 'Login successful', type: ToastTypeEnum.Success });
              localStorage.setItem('tenant-slug', tenantSlug);
              setTimeout(() => navigate('/'), 500);
            } else {
              setToast({ message: 'Login failed', type: ToastTypeEnum.Error });
              setTimeout(() => navigate('/login'), 1000);
            }
          });
      } catch (error) {
        setToast({
          message: 'Login failed',
          type: ToastTypeEnum.Error,
          detail: 'Please check your credentials.',
        });
        setTimeout(() => navigate('/login'), 1000);
      }
    };

    handleCallback();
  }, [dispatch, navigate]);

  return (
    <div className="sign-in row">
      {toast && <Toast message={toast.message} type={toast.type} />}
      {/* <LoadingScreen isVisible={true} /> */}
    </div>
  );
};

export default Callback;
